import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class SortDropdownClientDocument extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                <ButtonToolbar className = "btnToolbarSortMultipleExc pull-right" >
                    <DropdownButton
                          bsstyle="default"
                          title="Sort by"
                          noCaret
                          pullRight
                          id="dropdown-no-caret"
                          className="btnToolbarSortMultipleExc"
                          onSelect={this.props.sortResults}
                    >
                        <MenuItem eventKey="2"
                                  className="menuItemToolbarAddMultipleExc">
                            Date Created: Asc
                        </MenuItem>
                        <MenuItem eventKey="1"
                                  className="menuItemToolbarAddMultipleExc">
                            Date Created: Desc
                        </MenuItem>
                        <MenuItem eventKey="3"
                                  className="menuItemToolbarAddMultipleExc">
                            Assess. Title: Asc
                        </MenuItem>
                        <MenuItem eventKey="4"
                                  className="menuItemToolbarAddMultipleExc">
                            Assess. Title: Desc
                        </MenuItem>
                    </DropdownButton>
                </ButtonToolbar>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/SortDropdownClientAssessment.js